import * as fromDatatype from '../datatype-library/index';

export interface bl_sfa_sales_lead_event_RowInterface {
 
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid : fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  txn_type : fromDatatype.VarcharDatatypeInterface;
  action : fromDatatype.VarcharDatatypeInterface;
  descr : fromDatatype.VarcharDatatypeInterface;
  message_json : fromDatatype.JsonDatatypeInterface;
  completed_date : fromDatatype.TimestampTzDatatypeInterface;
  txn_date : fromDatatype.TimestampTzDatatypeInterface;
  event_code : fromDatatype.VarcharDatatypeInterface;
  id_user : fromDatatype.VarcharDatatypeInterface;
  id_device : fromDatatype.VarcharDatatypeInterface;
  id_user_agent : fromDatatype.VarcharDatatypeInterface;
  foreign_table : fromDatatype.VarcharDatatypeInterface;
  foreign_key : fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.GuidDataFieldInterface
  vrsn : fromDatatype.VarcharDatatypeInterface;
  
}

export class bl_sfa_sales_lead_event_RowClass implements bl_sfa_sales_lead_event_RowInterface {

  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid : fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  txn_type : fromDatatype.VarcharDatatypeInterface;
  action : fromDatatype.VarcharDatatypeInterface;
  descr : fromDatatype.VarcharDatatypeInterface;
  message_json : fromDatatype.JsonDatatypeInterface;
  completed_date : fromDatatype.TimestampTzDatatypeInterface;
  txn_date : fromDatatype.TimestampTzDatatypeInterface;
  event_code : fromDatatype.VarcharDatatypeInterface;
  id_user : fromDatatype.VarcharDatatypeInterface;
  id_device : fromDatatype.VarcharDatatypeInterface;
  id_user_agent : fromDatatype.VarcharDatatypeInterface;
  foreign_table : fromDatatype.VarcharDatatypeInterface;
  foreign_key : fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.GuidDataFieldInterface
  vrsn : fromDatatype.VarcharDatatypeInterface;

}
